import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const LimitOrderTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const { quantityBasis, inPosition } = tradePlan;
    const updateMarketOrder = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'LIMIT_ORDER',
        tradePlanId,
        null
      );
    };
    if (!tradePlan) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {quantityBasis === 'DOLLARS'
                      ? 'Dollar Amount'
                      : 'Qty. Amount'}
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    {quantityBasis === 'DOLLARS' ? '$' : '#'}
                  </Body3>
                  <EditableTableField
                    color={colors.lightGrey}
                    bodySize={3}
                    backgroundColor={colors.black}
                    disabled={inPosition}
                    initialValue={
                      tradePlan.entryTactics['LIMIT_ORDER'].quantityBasisValue
                    }
                    updateValue={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.entryTactics['LIMIT_ORDER']
                            .quantityBasisValue
                      )
                        updateMarketOrder('quantityBasisValue', newValue);
                    }}
                    inputType="number"
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Offset
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    color={colors.lightGrey}
                    bodySize={3}
                    backgroundColor={colors.black}
                    disabled={inPosition}
                    initialValue={
                      Number(
                        tradePlan.entryTactics['LIMIT_ORDER']
                          .offsetFromSetupPrice
                      ) * 100
                    }
                    updateValue={(newValue) => {
                      if (
                        newValue !== 0 &&
                        Number(newValue) !==
                          Number(
                            tradePlan.entryTactics['LIMIT_ORDER']
                              .offsetFromSetupPrice
                          ) *
                            100
                      )
                        updateMarketOrder(
                          'offsetFromSetupPrice',
                          newValue / 100
                        );
                    }}
                    inputType="number"
                  />
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    %
                  </Body3>
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Limit Price
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    $
                  </Body3>
                  <EditableTableField
                    color={colors.lightGrey}
                    bodySize={3}
                    backgroundColor={colors.black}
                    disabled={inPosition}
                    initialValue={
                      tradePlan.entryTactics['LIMIT_ORDER'].limitPrice
                    }
                    updateValue={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.entryTactics['LIMIT_ORDER']
                            .limitPrice
                      )
                        updateMarketOrder('limitPrice', newValue);
                    }}
                    inputType="number"
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);
LimitOrderTacticPanel.tabsRole = 'TabPanel';
